export type BrowserPageSnapshot = {
    pageCluster: string | undefined;
    avContentPageType: string | undefined;
    windowLocationUrl: string;
};

export function readBrowserPage(): BrowserPageSnapshot {
    return {
        pageCluster: document.documentElement.dataset.pagecluster,
        avContentPageType: document.getElementById('avContent')?.dataset.pt,
        windowLocationUrl: window.location.href,
    };
}
